import {Component, Inject, Input, OnInit} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {SettingsComponent} from '../settings.component';
import {AppComponent} from '../../app.component';
import {ConfService} from '../../conf.service';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {MatDialog, MatDialogRef} from '@angular/material';
import {GetPasswordComponent, ShowCredentialsComponent} from '../connectors/connectors.component';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {AddApiGatewayComponent} from './add-api-gateway/add-api-gateway.component';
import {AccountInfoService} from '../../user/account-info.service';

declare let $;
@Component({
  selector: 'app-api-gateway-settings',
  templateUrl: './api-gateway-settings.component.html',
  styleUrls: ['./api-gateway-settings.component.scss']
})
export class ApiGatewaySettingsComponent implements OnInit {

  data: any;
  gatewayPayload: any;
  flag: any;
  indexi: any;
  indexj: any;
  @Input() partner: any;
  @Input() partnerKey: any;
  @Input() account: any;
  @Input() payload: any;
  @Input() id: any;
  addConnection = true;
  configurationsGatewayPayload: any;

  dataLoading = true;
  isDataError = false;
  constructor(public settingComp: SettingsComponent,
              private dialog: MatDialog,
              public accountInfoService: AccountInfoService,
              public confPost: ConfService,
              public _service: ConnecttocrudService,
              public platform: LeftpanelComponent) { }

  ngOnInit() {
      if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
          this.platform.initialisePlatform();
      }
      this.getApiGateways();
            // if (this.payload && this.payload.length > 0) {
            //         for (let i = 0; i < this.payload.length; i++) {
            //             if (this.payload[i]['name'] === this.partner) {
            //                 this.indexi = i;
            //                 for (let j = 0; j < this.payload[i]['services'].length; j++) {
            //                     if (this.payload[i]['services'][j]['type'] === 'apigateway') {
            //                         this.indexj = j;
            //                         this.gatewayPayload = this.payload[i]['services'][j].configurations;
            //                         this.configurationsGatewayPayload = this.payload[i]['services'][j].configurations;
            //                         this.flag = true;
            //                     }
            //                 }
            //             }
            //         }
            //     } else {
            //         this.flag = false;
            //     }
  }


  getApiGateways() {
      this.dataLoading = true;
      this.isDataError = false;
      this.confPost.getAdvancedPartnerSettings(this.partner, this.account, localStorage.getItem('partnerKey')).subscribe(data => {
              let resp: any;
              resp = data;
              this.configurationsGatewayPayload = resp['apigateway'];
              this.dataLoading = false;
              this.isDataError = false;
          },
          error => {
              this.dataLoading = false;
              this.isDataError = true;
              this.platform.handleErrorGracefully(error, 'Error while getting list of API Gateways');
          });
  }

  openViewDialog(a) {
      const dialogRef = this.dialog.open(GetPasswordComponent, {
          data: JSON.stringify(this.configurationsGatewayPayload[a]['gateway_configurations']),
          width: 'auto',
          height: 'auto',
      });
  }
  deactivate(a) {
      this.payload[this.indexi]['services'][this.indexj].configurations[a].status = false;
      this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.id, {environments: this.payload}).subscribe(res => {
          if (!this.partner.includes('admin-') && !this.account.includes('admin-')) {
              this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(success => {
                  success['body'][0]['environments'][0] = this.payload[this.indexi];
                  this.confPost.patchItemServices('v2', 'settings', success['body'][0], success['body'][0]['id']).subscribe(data => {
                        alert('You have successfully deactivated the gateway');
                  }, error => {
                      alert('Error while deactivation. Please try again after sometime');
                  });
              }, error => {
                  alert('Error while deactivation. Please try again after sometime');
                  this.payload[this.indexi]['services'][this.indexj].configurations[a].status = true;
              });
          } else {
          alert('You have successfully deactivated the gateway.');
              this.payload[this.indexi]['services'][this.indexj].configurations[a].status = false;

          }
      }, error => {
          alert('Error while deactivating. Please try again after sometime.');
          this.payload[this.indexi]['services'][this.indexj].configurations[a].status = true;
      });
  }
  activate(a) {
      this.payload[this.indexi]['services'][this.indexj].configurations[a].status = true;
      this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.id, {environments: this.payload}).subscribe(res => {
          if (!this.partner.includes('admin-') && !this.account.includes('admin-')) {
              this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(success => {
                  success['body'][0]['environments'][0] = this.payload[this.indexi];
                  this.confPost.patchItemServices('v2', 'settings', success['body'][0], success['body'][0]['id']).subscribe(data => {
                      alert('You have successfully activated the gateway');
                  }, error => {
                      alert('Error while activation. Please try again after sometime');
                  });
              }, error => {
                  alert('Error while activation. Please try again after sometime');
                  this.payload[this.indexi]['services'][this.indexj].configurations[a].status = false;

              });
          } else {
              alert('You have successfully activated the gateway.');
              this.payload[this.indexi]['services'][this.indexj].configurations[a].status = true;

          }
      }, error => {
          alert('Error while activating. Please try again after sometime.');
          this.payload[this.indexi]['services'][this.indexj].configurations[a].status = false;
      });
  }
  deleteGateway(a) {
      if (confirm('Are you sure you want to delete this gateway connection?')) {
          this.payload[this.indexi]['services'][this.indexj].configurations.splice(a, 1);
          this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.id, this.payload).subscribe(res => {
              if (!this.partner.includes('admin-') && !this.account.includes('admin-')) {
                  this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(success => {
                      success['body'][0]['environments'][0] = this.payload[this.indexi];
                      this.confPost.patchItemServices('v2', 'settings', success['body'][0], success['body'][0]['id']).subscribe(data => {
                          alert('You have successfully deleted the gateway connection');
                      }, error => {
                          alert('Error while deleting. Please try again after sometime');
                      });
                  }, error => {
                      alert('Error while deleting. Please try again after sometime');
                  });
              } else {
                  alert('Deletion Successful');
              }
          }, error => {
              alert('Error while deleting. Please try again after sometime.');
          });
      }
  }
  stringifyjson(val) {
      return JSON.stringify(val);
  }

    addGateway() {
      const dialogRef = this.dialog.open(AddApiGatewayComponent, {
          width: '60%',
          data: {
              'partner': this.partner,
              'account': this.account,
              'partnerKey': this.partnerKey
          }
      });
      dialogRef.afterClosed().subscribe(response => {
          if (response) {
              this.dataLoading = true;
              setTimeout(() => {
                  this.getApiGateways();
              }, 1000);
          }
      });
  }

    updateGateway(data) {

        const dialogRef = this.dialog.open(AddApiGatewayComponent, {
            width: '60%',
            data: {
                'partner': this.partner,
                'account': this.account,
                'partnerKey': this.partnerKey,
                'isEdit': true,
                'apigateway': data
            }
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                this.dataLoading = true;
                setTimeout(() => {
                    this.getApiGateways();
                }, 1000);
            }
        });
    }

    deleteGatewayConfig(data) {
        if (confirm('Are you sure you want to delete this gateway connection?')) {
            this.dataLoading = true;
            this.confPost.manageApiGateways(this.partner, this.account, this.partnerKey, 'delete', {
                name: data.name,
                type: data.type,
            }).toPromise().then(response => {
                this.platform.openSnackBar('API Gateway deleted successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                setTimeout(() => {
                    this.getApiGateways();
                }, 1000);
            }, error => {
                this.dataLoading = false;
                this.platform.handleErrorGracefully(error, 'Error while deleting API gateway');
            });
        }
    }

  openDialog() {
      const dialogRef = this.dialog.open(AddNewGatewayComponent, {
          width: '90%',
          data: {
              'payload': this.payload,
              'partner': this.partner,
              'account': this.account
          }
      });
      dialogRef.afterClosed().subscribe(res => {
          if (res !== undefined) {
              this.payload[this.indexi]['services'][this.indexj].configurations.push(res);
          res.status = false;
          res.default = false;
          this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.id, this.payload).subscribe(res => {
              if (!this.partner.includes('admin-') && !this.account.includes('admin-')) {
                  this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(success => {
                      success['body'][0]['environments'][0] = this.payload[this.indexi];
                      this.confPost.patchItemServices('v2', 'settings', success['body'][0], success['body'][0]['id']).subscribe(data => {
                          alert('You have successfully added the gateway connection');
                      }, error => {
                          alert('Error while adding. Please try again after sometime');
                      });
                  }, error => {
                      alert('Error while adding. Please try again after sometime');
                  });
              } else {
                  alert('Addition Successful');
              }
          }, error => {
              alert('Error while adding. Please try again after sometime.');
          });
        }
      });
  }
}

@Component({
    selector: 'app-addNewGateway',
    templateUrl: './AddNewGateway.component.html',
    styleUrls: ['./AddNewGateway.component.scss']
})
export class AddNewGatewayComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<AddNewGatewayComponent>, public confPost: ConfService, @Inject(MAT_DIALOG_DATA) public data: any) {
        dialogRef.disableClose = true;
    }
    APIGateways = [
        {
            gateway: 'apiplatform',
            image: './assets/img/partnerOnboarding/api.png',
            description: 'Default',
            value: 'default'
        },
        {
            gateway: 'Kong',
            image: './assets/img/kong.png',
            description: 'Kong',
            value: 'kong'
        },
        {
            gateway: 'Google',
            image: './assets/img/partnerOnboarding/apigee.png',
            description: 'APIGEE',
            value: 'apigee'
        },
        {
            gateway: 'Microsoft',
            image: './assets/img/partnerOnboarding/azure.png',
            description: 'Azure',
            value: 'azure'
        },
        {
            gateway: 'Amazon',
            image: './assets/img/partnerOnboarding/awsGateway.png',
            description: 'AWS API Gateway',
            value: 'aws'
        }
    ];
    connectionDetailsKongSchema = {
    };
    connectionDetailsSchema = {
        'name': '',
        'provider': '',
        'gatewayConfigurations': '',
        'url': '',
        'audit_log': []
    };
    connectionDetailsKong = ['Name', 'Url'];
    selectedGateway: any;
    connectionDetails: any;
    cloudConfig: any;
    ngOnInit(): void {
        const time = new Date();
        this.cloudConfig = this.data.payload;
    }
    addNewConnection() {
        if (this.selectedGateway === undefined) {
            alert('Please select a gateway to continue adding connection');
        } else {
            this.dialogRef.close(this.connectionDetailsSchema);
        }
    }
    close() {
        this.dialogRef.close();
    }
    selectGateway(index) {
        this.selectedGateway = this.APIGateways[index];
        if (this.selectedGateway.value !== 'default') {
            this.connectionDetails = this.connectionDetailsKong;
            this.connectionDetailsSchema.provider = this.selectedGateway.value;
        } else {
            this.connectionDetails = [];
            this.connectionDetailsSchema.provider = this.selectedGateway.value;
        }
            for (let i = 0; i < this.APIGateways.length; i++) {
                const id = 'selectedGateway' + i;
                if (index === i) {
                    $('#' + id).css('border', '2px solid #ff672d');
                } else {
                    $('#' + id).css('border', 'transparent');
                }
            }
    }
}
